<!-- 
Deletes a levy collection then returns to the home page.
We do it this way because deleting a levy collection without moving off a page
containing levy collection components will make all the components try
to reload themselves - which will cause errors because the LC no longer exists.
-->
<template>
  <div>
    <strong>Deleting levy collection, please wait...</strong>
  </div>
</template>

<script>
import * as action from "@/store/levy-collections/action-types";

export default {
  computed: {
    levyCollectionId() {
      return parseInt(this.$route.params.id);
    }
  },
  async mounted() {
    await this.$store.dispatch(action.TASK_RUN, {
      levyCollectionId: this.levyCollectionId,
      type: "Delete",
      description: "Delete levy collection"
    });
    this.$router.replace("/");
  }
};
</script>
